import { formatCurrency } from './index';

export type FeeBreakdownItem = {
  key: string;
  label: string;
  amount: number;
  rate?: number | null;
};

export type FeeBreakdown = {
  items: FeeBreakdownItem[];
  totalFeeUsd: number;
  totalFeeRate?: number | null;
};

function formatFeeLine(amount: number, rate?: number | null): string {
  if (rate != null && rate > 0) {
    return `${formatCurrency(amount, 'USD')} (${(rate * 100).toFixed(0)}%)`;
  }
  return formatCurrency(amount, 'USD');
}

/** Build timeline meta rows for itemized fees (gateway / system / network / total). */
export function buildFeeBreakdownMetaKvs(breakdown: FeeBreakdown | null | undefined): Array<{ label: string; value: string }> {
  if (!breakdown?.items?.length) return [];

  const lines = breakdown.items
    .filter((item) => item.amount > 0.0001)
    .map((item) => ({
      label: item.label,
      value: formatFeeLine(item.amount, item.rate),
    }));

  if (lines.length > 1) {
    lines.push({
      label: 'Total fee',
      value: formatFeeLine(breakdown.totalFeeUsd, breakdown.totalFeeRate),
    });
  }

  return lines;
}

/** Fallback when API did not send feeBreakdown (gross/net delta only). */
export function buildSingleFeeMetaKv(grossAmount: number, feeAmount: number): { label: string; value: string } {
  const feeRate = grossAmount > 0 ? feeAmount / grossAmount : 0;
  return {
    label: 'Fee',
    value: formatFeeLine(feeAmount, feeRate > 0 ? feeRate : null),
  };
}
